import React from "react";

const ReslutList = ({ results = [], loading }) => {
  if (loading) {
    return <p className="text-white text-center mt-4">Loading...</p>;
  }

  if (!results.length) {
    return <p className="text-white text-center mt-4">No results found.</p>;
  }

  const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  };

  return (
    <div className="">
      {results.map((item, index) => {
        const { settledAt, event, runners, selection } = item;
        const home = runners[0]?.runnerName || "-";
        const away = runners[1]?.runnerName || "-";


        const isHomeWinner = home === selection;
        const loser = isHomeWinner ? home : away;
        const winner = isHomeWinner ? away : home;

        return (
          <div
            key={index}
            className="flex items-start border-b border-[#7e97a7] w-full max-w-2xl bg-white shadow  overflow-hidden"
          >
   
            <div className="w-[50%] p-2 border-r border-[#e0e6e6]">
              <p className="text-[12px] text-[#666666] mb-1">
                {formatDateTime(settledAt)}
              </p>
              <p className="text-[14px] leading-[22px] font-bold text-[#333]">
                {event}
              </p>
            </div>

     
            <div className="flex w-[50%] text-center">
              <div className="border-r border-[#e0e6e6] w-[50%]">
                <p className="text-[10px] text-green font-semibold mb-1 mt-2">
                  Winner
                </p>
                <p className="text-[11px] font-bold text-black">{winner}</p>
              </div>
              <div className="w-[50%]">
                <p className="text-[10px] text-red-600 font-semibold mb-1 mt-2">
                  Loser
                </p>
                <p className="text-[11px] font-bold text-black">{loser}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReslutList;
